import React from "react";
import { twMerge } from "tailwind-merge";

interface PillType {
  title?: string;
  variant: "DEFAULT" | "INFO" | "READ" | "WARNING";
  className?: string;
  subTitle?: string;
}

const Pill = ({ title, variant, subTitle, className }: PillType) => {
  return (
    <div className="flex flex-col mb-2 gap-3">
      {title && <div
        className={twMerge(
          `rounded-full border px-5 py-[0.25rem] text-sm w-fit bg-primary text-white`,
          className,
        )}
      >
        {title}
      </div>
}
      {subTitle && (
        <div className=" font-semibold text-primary uppercase">{subTitle}</div>
      )}
    </div>
  );
};

export default Pill;
